import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { handleToastError } from 'helpers';
import { getSelectedCentre } from 'store/master';
import reportApi from 'api/reportApi';
import { useUser } from '../../../hooks';
import { useSelector } from 'react-redux';
import { ArrowDown, ArrowUp } from 'react-feather';
const DonutChart = ({ totalClass }) => {
  const auth = useUser();
  const selectedCentre = useSelector(getSelectedCentre);
  const [newcourses, setNewCourses] = useState();

  async function donutChartdetails() {
    try {
      const response = await reportApi.getDonutChartValue(
        auth?._id,
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      setNewCourses(response);
    } catch (error) {
      handleToastError(error);
    }
  }
  useEffect(() => {
    donutChartdetails();
  }, [selectedCentre]);

  const disable =
    newcourses?.completedCourses ||
    newcourses?.coursesInProgress ||
    newcourses?.coursesNotStarted;

  const data = disable
    ? {
        labels: ['Completed', 'Inprogress', 'Not Started'],
        datasets: [
          {
            label: '# of Votes',
            data: [
              newcourses?.completedCourses,
              newcourses?.coursesInProgress,
              newcourses?.coursesNotStarted,
            ],
            backgroundColor: ['#43B58A', '#D6B409', '#3553A3'],
            borderColor: ['#43B58A', '#D6B409', '#3553A3'],
            borderWidth: 1,
          },
        ],
      }
    : {
        labels: ['Completed', 'Inprogress', 'Not Started'],
        datasets: [
          {
            label: '# of Votes',
            data: [1, 1, 1],
            backgroundColor: ['#c8c8c8', '#c8c8c8', '#c8c8c8'],
            borderColor: ['#c8c8c8', '#c8c8c8', '#c8c8c8'],
            borderWidth: 1,
          },
        ],
      };

  const options = {
    width: '50',
    height: '60',
    legend: {
      display: true,
      position: 'right',
      labels: {
        boxWidth: 25,
      },
    },
    tooltips: {
      mode: !disable ? null : 'label',
    },
    hover: {
      mode: !disable ? null : 'label',
    },
    cutoutPercentage: 80,
  };

  return (
    <>
      <div className="col">
        <h5 className="view-page-title">Total Classes</h5>
        <p className="card-header-title-label">
          {totalClass}
          {totalClass ? (
            <ArrowUp
              style={{
                color: newcourses?.newCourses ? 'green' : '#646871',
                marginTop: -3,
              }}
              size={18}
            />
          ) : (
            <ArrowDown
              style={{
                color: newcourses?.newCourses ? 'green' : '#646871',
                marginTop: -3,
              }}
              size={18}
            />
          )}
          <span
            style={{
              color: newcourses?.newCourses ? 'rgb(76,218,92)' : '#646871',
            }}
          >
            {newcourses?.newCourses} NEW
          </span>
        </p>
        <Doughnut options={options} data={data} />
      </div>
    </>
  );
};

export default DonutChart;
